import React from "react";
import useQbBasket from "./useQbBasket";
import { useTranslation } from "react-i18next";
import QbBasketInputs from "./QbBasketInputs";
import { BasketItem } from "../../../models/BasketItem";
import EATable from "../../shared/Table/EATable";
import EAModal from "../../shared/Modal/EAModal";
import EAAlert from "../../shared/EAAlert";

interface IProps {
  onClose: () => void;
}

const QbBasket: React.FC<IProps> = ({ onClose }) => {
  const { loading, data, error, updateBasketItem, onUpdateBasket, basketLength, hasDuplicateQbCards, isQbRowDuplicateCard } =
    useQbBasket(onClose);
  const { t } = useTranslation();
  return (
    <EAModal
      isOpen
      onClose={onClose}
      title="Wykorzystaj promocję do wybranych biletów"
      onAccept={onUpdateBasket}
      loading={loading}
      acceptButtonLabel="Zastosuj promocje"
      disabledAccept={basketLength === 0 || hasDuplicateQbCards}
    >
      <div className="qb-table">
        <EATable
          columns={[
            {
              key: "assortName",
              header: t("nazwa"),
              render: (value, row) => (
                <>
                  <p className="no-line-height">{value}</p>
                  <br />
                  {row.validFrom && (
                    <span className="caption no-line-height">
                      {" "}
                      {t("data_rozpoczecia")}: {row.validFrom}
                    </span>
                  )}
                </>
              ),
            },
            { key: "price", header: t("cena"), type: "price" },
            {
              key: "inputs",
              header: "",
              render: (value, row, index) => (
                <QbBasketInputs
                  index={index}
                  itemData={row as BasketItem}
                  onUpdateBasketItem={updateBasketItem}
                  isDuplicateQbCard={isQbRowDuplicateCard(index)}
                />
              ),
            },
          ]}
          data={data.basket ?? []}
          noDataLabel="Koszyk jest pusty"
        />
      </div>
      {error && <EAAlert type="error" message={error} />}
    </EAModal>
  );
};

export default QbBasket;
